var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"54","height":"54","viewBox":"0 0 54 54","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M27.0002 0V54","stroke":"#5A55F4","stroke-width":"4"}}),_vm._v(" "),_c('path',{attrs:{"d":"M54 27L1.3113e-06 27","stroke":"#5A55F4","stroke-width":"4"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }